module.exports = __webpack_public_path__ + "static/media/folding.ab5e3dec.jpg";